
import { computed, defineComponent } from 'vue';
import { useStore } from '@/store';
import CustomObjects from '@/views/my-shop-data/CustomObjects.vue';
import DataExplorerLink from '@/components/data-explorer/fields/DataExplorerLink.vue';

export default defineComponent({
  name: 'CustomDataFile',
  components: {
    CustomObjects,
    DataExplorerLink,
  },
  setup() {
    const store = useStore();
    const selectedData = computed(() => store.getters['dataExplorer/getSelectedData']);
    const customObjectsContext = computed(() => ({
      mode: 'embedded',
      relation: {
        target: 'contact',
        id: selectedData.value?.idShopContact,
        sourceField: selectedData.value?.sourceField,
      },
      ui: {
        showHeader: false,
        showBackLink: false,
        showImport: false,
        showFilters: false,
      },
    }));

    return {
      selectedData,
      customObjectsContext,
    };
  },
});
